import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from "moment";
import ReactHighcharts from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import { groupBy } from '../../../helpers/common';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/full-screen')(Highcharts);

HighchartsNoData(Highcharts);

const AllUtilizationChart = (props) => {
  const { searchParams } = props;
  const sourceDetailsById = useSelector(state => state.dashboard.leaderBoard.sourceListById.payload);
  const [graphData, setData] = useState(null);
  const [name, setName] = useState('Chart');
  const sourceDetailList = Object.keys(sourceDetailsById).map(id => sourceDetailsById[id]);
  const filteredList = sourceDetailList.filter(e => e.utilization > 0 && e.loadCount !== null);

  useEffect(() => {
    const fromDate = moment(searchParams.custom.from);
    const toDate = moment(searchParams.custom.to);
    let nameFormat = `Utilization_${moment(fromDate).format("DD MMM YY")} to ${moment(toDate).format("DD MMM YY")}`;

    if (searchParams.customRange === "todate" || searchParams.customRange === "planned") {
      searchParams.customRange === "todate" ? nameFormat = "Utilization_todate" : nameFormat = "Utilization_planned";
    }

    setName(nameFormat);
  }, [searchParams]);

  useEffect(() => {
    let groupArr = [];
    let toDateValues = [];
    let toDateDate = [];

    filteredList.forEach(item => {
      const utilization = item.utilizationPerDay;

      const sortedUtilization = utilization.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });

      groupArr.push(...sortedUtilization)

    });

    const sortedGroup = groupBy("date")(groupArr);
    Object.keys(sortedGroup).sort(function (a, b) {
      return new Date(a) - new Date(b);
    }).forEach(e => {
      const nonZeroImplement = sortedGroup[e].filter(e => e.utilization > 1);
      let value = (nonZeroImplement.reduce((a, b) => a + b.utilization, 0)) / nonZeroImplement.length;
      const utilization = !isNaN(value) ? value : 0;
      const formattedDate = moment(e).format("DD MMM YYYY");

      toDateValues.push(utilization);
      toDateDate.push(formattedDate);
    });

    const graphValues = { date: toDateDate, data: toDateValues };
    setData(graphValues);
  }, []);

  let value = {
    chart: {
      type: 'column',
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: graphData ? graphData.date : [0],
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Utilization %'
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f} %</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.0f}%'
        }
      }
    },
    series: graphData ? { name: "Utilization", data: graphData.data } : [0],
    legend: {
      enabled: false
    },
    exporting: {
      filename: name,
      buttons: {
        contextButton: {
          menuItems: [
            'viewFullscreen',
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'downloadCSV'
          ]
        }
      }
    },
  }

  return <ReactHighcharts config={value} options={value}></ReactHighcharts>
};

export default AllUtilizationChart;






